import React from 'react';
import { Link } from 'react-router-dom';
import addCircleIcon from '../assets/add-circle.svg';

const addCircle = { path: addCircleIcon };

export const AddPublicationButton = (): JSX.Element => (
    <Link
        className="ml-2 flex leading-6 rounded-[1.5rem] w-fit text-medium font-medium border border-primary bg-primary items-center content-center px-[20px] py-[20px] text-dark-gray flex-row justify-center max-h-12"
        to="/add_publication"
    >
        <img src={addCircle.path} className="mr-2 w-6" alt="add circle icon" />
        Créer une publication
    </Link>
);
